module.exports = __webpack_public_path__ + "static/img/text1.71b0b61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/text1.png
// module id = h4np
// module chunks = 1